import { render, staticRenderFns } from "./movGastosList.vue?vue&type=template&id=ff5c91c8&"
import script from "./movGastosList.vue?vue&type=script&lang=js&"
export * from "./movGastosList.vue?vue&type=script&lang=js&"
import style0 from "./movGastosList.vue?vue&type=style&index=0&id=ff5c91c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports